<template>
  <div>
    <div v-if="getting" class="flex justify-center h-[50vh]">
      <spinner class="w-20 h-20" color="oneGreen" />
    </div>

    <div
      v-else-if="notFound || !printout"
      class="w-full flex flex-col justify-center items-center h-[50vh]"
    >
      <img
        src="@/assets/images/icons/broken_link.svg"
        alt="icon"
        class="w-20 h-20 transform rotate-180"
      />

      <p class="text-red-400 font-bold mt-2">
        Printout not Available right now, make sure you filled all fields
      </p>
    </div>

    <div v-else class="">
      <div id="printout" v-html="printout"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PromotionPrintout",
  props: {
    staffData: {
      type: Object,
      default: null,
      required: false,
    },
  },
  data() {
    return {
      printout: null,
      getting: false,
      notFound: false,
    };
  },
  created() {
    this.fetchPrintout();
  },
  methods: {
    async fetchPrintout() {
      this.getting = true;
      const res = await this.$http.post(
        `/staff-promotion/certificate/${
          this.staffData._id ? this.staffData._id : this.staffData.id
        }`,
        {
          baseUrl: `${window.location.origin}/promotion`,
        },
        { headers: { noauth: true } }
      );

      if (!res) {
        return;
      }
      const { data } = res;
      this.getting = false;

      if (data && data.code) {
        this.notFound = true;
        this.$swal({
          icon: "info",
          text: data.message,
        });
        return;
      }
      this.notFound = false;
      this.printout = data;
    },
  },
};
</script>

<style scoped>
@media print {
  body * {
    visibility: hidden;
  }

  #printout,
  #printout * {
    visibility: visible;
  }
}
</style>
